import generateFiltersModule from '@/store/_generateFiltersModule';
import localConfig from '@/config';

const initialState = {
    offers: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-id',
            paused: 0,
            filter_results_local: 1,
        },
    },
    adAccounts: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-id',
            paused: 0,
        },
    },
    extCampaigns: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-id',
            paused: 0,
            ext_status: 'active',
        },
    },
    extCampaignOffers: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-id',
        },
    },
    partners: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
            paused: 0,
        },
    },
    advertisers: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
            paused: 0,
        },
    },
    splitters: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
            advanced: 0,
        },
    },
    onboardings: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    approvals: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created_ext',
            status: ['pending'],
        },
    },
    postbacksReport: {
        isChanged: false,
        useSessionStorage: true,
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-timestamp',
            filter_results_local: 1,
        },
    },
    eventsReport: {
        useSessionStorage: true,
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-timestamp',
            filter_results_local: 1,
        },
    },
    clicksReport: {
        useSessionStorage: true,
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-timestamp',
            filter_results_local: 1,
        },
    },
    blockedClicksReport: {
        useSessionStorage: true,
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-timestamp',
            filter_results_local: 1,
        },
    },
    serverReport: {
        useSessionStorage: true,
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-timestamp',
            filter_results_local: 1,
            status: 'failed',
        },
    },
    schedules: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    trafficFiltering: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-id',
        },
    },
    blacklistControlPublishers: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
            filter_results_local: 1,
        },
    },
    blacklistControlTsp: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
            filter_results_local: 1,
        },
    },
    tasks: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-id',
        },
    },
    applications: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
        },
    },
    advertiserWhitelists: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    fraudProtectionAdvertisers: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    fraudProtectionOffers: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    fraudProtectionPublishers: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    fraudProtectionTrackingLinks: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    trafficControlItems: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    trafficControlFiles: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    offerOptimizations: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    offerCreativeRequests: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    offerTriggers: {
        filters: {
            offset: 0,
            limit: 300,
            sort: '-created',
        },
    },
    kpiControl: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    foreignCampaignsList: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-id',
        },
    },
};


export default {
    namespaced: true,
    modules: {
        offers: generateFiltersModule(initialState.offers, 'offers'),
        adAccounts: generateFiltersModule(initialState.adAccounts, 'adAccounts'),
        extCampaigns: generateFiltersModule(initialState.extCampaigns, 'extCampaigns'),
        extCampaignOffers: generateFiltersModule(initialState.extCampaignOffers, 'extCampaignOffers'),
        partners: generateFiltersModule(initialState.partners, 'partners'),
        advertisers: generateFiltersModule(initialState.advertisers, 'advertisers'),
        splitters: generateFiltersModule(initialState.splitters, 'splitters'),
        onboardings: generateFiltersModule(initialState.onboardings, 'onboardings'),
        approvals: generateFiltersModule(initialState.approvals, 'approvals'),
        postbacksReport: generateFiltersModule(initialState.postbacksReport, 'postbacksReport'),
        eventsReport: generateFiltersModule(initialState.eventsReport, 'eventsReport'),
        clicksReport: generateFiltersModule(initialState.clicksReport, 'clicksReport'),
        blockedClicksReport: generateFiltersModule(initialState.blockedClicksReport, 'blockedClicksReport'),
        serverReport: generateFiltersModule(initialState.serverReport, 'serverReport'),
        schedules: generateFiltersModule(initialState.schedules, 'schedules'),
        trafficFiltering: generateFiltersModule(initialState.trafficFiltering, 'trafficFiltering'),
        blacklistControlPublishers: generateFiltersModule(initialState.blacklistControlPublishers, 'blacklistControlPublishers'),
        blacklistControlTsp: generateFiltersModule(initialState.blacklistControlTsp, 'blacklistControlTsp'),
        tasks: generateFiltersModule(initialState.tasks, 'tasks'),
        applications: generateFiltersModule(initialState.applications, 'applications'),
        advertiserWhitelists: generateFiltersModule(initialState.advertiserWhitelists, 'advertiserWhitelists'),
        fraudProtectionAdvertisers: generateFiltersModule(initialState.fraudProtectionAdvertisers, 'fraudProtectionAdvertisers'),
        fraudProtectionOffers: generateFiltersModule(initialState.fraudProtectionOffers, 'fraudProtectionOffers'),
        fraudProtectionPublishers: generateFiltersModule(initialState.fraudProtectionPublishers, 'fraudProtectionPublishers'),
        fraudProtectionTrackingLinks: generateFiltersModule(initialState.fraudProtectionTrackingLinks, 'fraudProtectionTrackingLinks'),
        trafficControlItems: generateFiltersModule(initialState.trafficControlItems, 'trafficControlItems'),
        trafficControlFiles: generateFiltersModule(initialState.trafficControlFiles, 'trafficControlFiles'),
        offerOptimizations: generateFiltersModule(initialState.offerOptimizations, 'offerOptimizations'),
        offerCreativeRequests: generateFiltersModule(initialState.offerCreativeRequests, 'offerCreativeRequests'),
        offerTriggers: generateFiltersModule(initialState.offerTriggers, 'offerTriggers'),
        kpiControl: generateFiltersModule(initialState.kpiControl, 'kpiControl'),
        foreignCampaignsList: generateFiltersModule(initialState.foreignCampaignsList, 'foreignCampaignsList'),
    },
};
